import { render } from "./ActivePosting.vue?vue&type=template&id=278cb34a&scoped=true"
import script from "./ActivePosting.vue?vue&type=script&lang=js"
export * from "./ActivePosting.vue?vue&type=script&lang=js"

import "./ActivePosting.vue?vue&type=style&index=0&id=278cb34a&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278cb34a"]])

export default __exports__